module.exports = __webpack_public_path__ + "static/assets/3ee09a6f5317cb3c14d1e09da9261cae.svg";